module.exports = new __parcel__URL__("scratch_select.3997065f.mp3").toString();